import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';


@Component({
    selector: 'eas-editor-eligibility-rule-form-is-raw-operator',
    templateUrl: './editor-eligibility-rule-form-is-raw-operator.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleFormIsRawOperatorComponent implements OnInit {
  @Input() formGroup: FormGroup;

  constructor() {

  }

  ngOnInit() {

  }

  getFormControl(name): FormControl {
    return this.formGroup.controls[name] as FormControl;
  }
}
